function returnValueBasedOnProduct(productResultMap) {
    const url = window.location.href;
    if (productResultMap.motorhome && url.includes('motorhome-insurance')) {
        return productResultMap.motorhome;
    }
    if (productResultMap.car && (url.includes('car-insurance') || url.includes('motorhome-insurance') || url.includes('renewcar'))) {
        return productResultMap.car;
    }
    if (productResultMap.home && url.includes('home-insurance')) {
        return productResultMap.home;
    }
    if (productResultMap.quickQuote && url.includes('quick-quote')) {
        return productResultMap.quickQuote;
    }
    if (productResultMap.smi && url.includes('health-insurance')) {
        return productResultMap.smi;
    }
    if (productResultMap.spt && url.includes('travel-insurance')) {
        return productResultMap.spt;
    }
    return '';
}

const SG_AA_FIELDS_ADDONS = {
    hasLegalCover: { name: 'Legal Protection', price: 15 },
    hasPersonalAccidentCover: { name: 'Increased Personal Accident', price: 13 },
    hasRCECover: { name: 'Replacement Car Extension', price: 20 },
    hasKeyProtection: { name: 'Key Protection', price: 9.99 },
    hasBuildingsAccidentCover: { name: 'Buildings Accidental Damage' },
    hasContentsAccidentCover: { name: 'Contents Accidental Damage' },
    unspecifiedItemsCover: {
        name: 'Personal Belongings',
        valueMap: {
            two_thousand_five_hundred: 2500,
            five_thousand: 5000,
            ten_thousand: 10000
        }
    },
    hasSheCover: {
        name: 'Home Emergency Cover',
        valueMap: {
            1: 'Lvl 1', 2: 'Lvl 2', 3: 'Lvl 3', 4: 'Lvl 4'
        }
    },
    homeLegalExpensesCoverQuestion: { name: 'Home Legal Expenses', price: 26.50 },
    rentGuaranteeCoverQuestion: { name: 'Rent Guarantee Cover', valueMap: { 2500: 2500, 5000: 5000 } },
    // Breakdown
    hasBreakdownCover: { id: 'Breakdown -' },
    // Breakdown Level of Cover// us4223 SBA change of provider, old prices need removing after 01/05/19
    essential: { price: 29.99 }, // Breakdown journey prices
    home_call: { price: 69.99 },
    national_recovery: { price: 69.99 },
    comprehensive: { price: 99.99 },
    premier: { price: 124.99 },
    // Breakdown Level of Cover Motorhome
    assistance: { price: 69.99 },
    assistance_plus: { price: 99.99 },
};

// Adobe Analytics Product types
const SG_AA_COVER_TYPE_PRODUCT = {
    PERSONAL_AUTO: 'Car Insurance'
};

// Adobe Analytics productActionLocation values
const SG_AA_PROD_ACTION_LOC = {
    BEFORE_PREMIUM_PAGE: 'prior to premium page',
    PREMIUM_PAGE: 'premium page',
    UPGRADE_PREMIUM_PAGE: 'upgrade page',
    BREAKDOWN_PAGE: 'breakdown page',
    RETRIEVAL_SUMMARY_PAGE: 'summary page'
};

// Adobe Analytics productActionReason values
const SG_AA_PROD_ACTION_REASON = {
    MAIN_PRODUCT_ADD: 'main product add',
    MAIN_PRODUCT_CHANGE: 'main product change',
    PACKAGE_CHANGE: 'package add-on change',
    ADDON_CHANGE: 'single add-on change',
    SWITCHED_FROM_FIXED: 're-added after switching from fixed price'
};

// Adobe Analytics BHpremiumPageAction values
const SG_AA_PREMIUM_PAGE_ACTION = {
    LEVEL_1: { // First Element (page area)
        TAILOR_YOUR_COVER: 'tailor',
        SPECIAL_OFFERS: 'special offers',
        ADD_ONS: 'add ons',
        REVIEW: 'review',
        CONTINUE_TOP: 'continue top',
        DECLARATIONS: 'declarations',
        CONTINUE_BOTTOM: 'continue bottom',
        FOOTER: 'footer',
        ADDITIONAL_COVER: 'additional cover',
        CHOOSE_LEVEL: 'choose level',
        BREADCRUMBS: 'breadcrumbs',
        SWITCH_COVER_LEVEL: 'switch cover level',
        PAYMENT_PODS: 'payment pods',
        DEFAQTO_TOOL_LINK: 'defaqto tool link',
        COMPARISON_TABLE_BUTTON: 'comparison table button'
    },
    LEVEL_2: { // Second Element (type of link)
        DROP_DOWN: 'drop down',
        CALENDAR: 'calendar',
        TEXT: 'text',
        CTA: 'cta',
        CLICK_ON_POD: 'click on pod',
        CLICK_ON_TABLE: 'click on table'
    },
    LEVEL_3: { // Third Element (content of link)
        COVER_TYPE: 'cover type',
        COVER_START: 'cover start',
        BUNDLE_ADD_ON: 'bundle add on',
        SINGLE_ADD_ON: 'single add on',
        BREAKDOWN_COVER: 'breakdown cover',
        DESCRIPTION: 'description',
        REGISTRATION: 'registration',
        NCD: 'no claims discount',
        ANNUAL_MILEAGE: 'annual mileage',
        ENGINE_SIZE: 'engine size',
        MODIFICATIONS: 'modifications',
        MORE_VEH_DETAILS: 'more vehicle details',
        NAME: 'name',
        DOB: 'dob',
        EMAIL: 'email',
        MORE_DRIVER_DETAILS: 'more driver details',
        ADD_DRIVER: 'add driver',
        TYPE_OF_USE: 'type of use',
        ADDRESS: 'address',
        CREDIT_ACT: 'credit act',
        IMPORTANT_STATEMENTS: 'important statements',
        SUMMARY_OF_COVER: 'summary of cover',
        POLICY_BOOKLET: 'policy booklet',
        SECCI: 'secci',
        BACK_TO_PREMIUM: 'back to premium',
        TOP_BACK_TO_PREMIUM: 'top back to premium',
        BACK_BUTTON: 'back button',
        EDIT_COVER: 'edit cover',
        TO_PREMIUM: 'to premium',
        ADD_ANOTHER_CAR: 'add another car',
        FIXED_PRICE_DOWNGRADE: 'downgrade',
        FIXED_PRICE_COMPARE_COVER: 'compare cover',
        NCD_MODAL: 'pncd modal',
        PREMIUM_CHANGED: 'premium changed information',
        MONTHLY_NOT_AVAILABLE: 'monthly not available information',
        SELECT: 'select',
        PLUS: 'plus',
        ANNUAL: 'annual',
        MONTHLY: 'monthly',
        SHOW_DEFAQTO_TABLE: 'show Defaqto Table',
        SHOW_ALL_FEATURES: 'show all features',
        SHOW_COMPARISON_TABLE: 'show Comparison Table',
        SAGA_PLUS_TERMS: 'Saga Plus terms and conditions',
        VOLUNTARY_EXCESS: 'voluntary excess',
        CSD: 'cover start date',
        PRIVACY_POLICY: 'privacy policy',
        ACCIDENT_HEALTHCARE_POLICY_BOOKLET: 'accident healthcare policy booklet',
        BREAKDOWN_POLICY_BOOKLET: 'breakdown policy booklet',
        IPID: 'ipid',
        FRAUD: 'fraud prevention',
        TO_PAYMENT: 'to payment'
    },
    LEVEL_4: {
        BREAKDOWN: 'breakdown',
    }
};

// Adobe Analytics pageName(s)
const SG_AA_PAGE_NAME = {
    INSURANCE: 'insurance',
    INSURANCE_TYPE: returnValueBasedOnProduct({
        car: 'car insurance',
        home: 'home insurance',
        motorhome: 'motorhome insurance',
        quickQuote: 'quick quote',
        smi: 'health insurance',
        spt: 'travel insurance'
    }),
    GET_QUOTE: 'get quote',
    // Renewal
    RENEWAL_DETAILS: 'renew',
    RENEWAL_MOTOR: 'car insurance',
    RENEWAL_SUMMARY: 'renewalsummary',
    RENEWAL_PAYMENT: 'cardpayment',
    RENEWAL_BASE: 'renew',
    RENEWAL_CONFIRMATION: 'confirmation',
    // CEP
    MY_SAGA: 'mysaga',
    MANAGE_POLICY: 'manage-policy'
};

const SG_CEP_MTA_SUMMARY_PAGES = [
    'summary',
    'statements'
];

// Adobe Analytics ctaText(s)
const SG_AA_CTA_TEXT = {
    MOTOR_LANDING_CONTINUE: 'motorLandingContinue',

    VEHICLE_DETAILS_NEXT: 'vehicleDetailsNext',
    VEHICLE_USING_CAR_TEXT: 'vehicleUsingCarNext',
    VEHICLE_YOUR_COVER_TEXT: 'vehicleYourCoverNext',
    VEHICLE_CONTINUE: 'vehicleContinue',

    // WOC-2959 - start
    YOUR_VEHICLE_DETAILS_NEXT: 'yourVehicleDetailsNext_WOC2959',
    YOUR_VEHICLE_USING_CAR_TEXT: 'yourVehicleUsingCarNext_WOC2959',
    YOUR_VEHICLE_CONTINUE: 'yourVehicleContinue_WOC2959',

    ENHANCE_YOUR_COVER_CONTINUE: 'enhanceYourCoverContinue_WOC2959',
    // WOC-2959 - end

    SMI_HEALTH_CONDITIONS_NEXT: 'preExistingConditionsQuestionsNext',
    SMI_COVER_DETAILS_NEXT: 'coverDetailsQuestionsNext',

    DRIVERS_YOUR_DETAIL_NEXT: 'driversYourDetailsNext',
    DRIVERS_YOUR_EMPLOYMENT_NEXT: 'driversYourEmploymentNext',
    DRIVERS_YOUR_ADDRESS_NEXT: 'driversYourAddressNext',
    DRIVERS_DRIVING_HISTORY_NEXT: 'driversDrivingHistoryNext',
    DRIVERS_CONVICTIONS_NEXT: 'driversConvictionsNext',
    DRIVERS_CONTINUE: 'driversContinue',

    SUMMARY_EDIT_POLICY_HOLDER: 'summaryEditPolicyHolder',
    SUMMARY_ADD_ANOTHER_DRIVER: 'summaryAddAnotherDriver',
    SUMMARY_ADDITIONAL_DRIVER_EDIT: 'summaryAdditionalDriverEdit',
    SUMMARY_ADDITIONAL_DRIVER_REMOVE: 'summaryAdditionalDriverRemove',
    SUMMARY_BACK: 'summaryBack',

    BLANK_REG_BACK: 'blankRegistrationBack',
    BLANK_REG_CONTINUE: 'blankRegistrationContinue',

    CUE_BACK: 'cueBack',
    CUE_CONTINUE: 'cueContinue',

    DECLARATION_NCD_NEXT: 'declarationNcdNext',
    DECLARATION_COMM_PREFS_NEXT: 'declarationCommunicationPreferencesNext',
    DECLARATION_MONTHLY_PAYMENTS_NEXT: 'declarationMonthlyPaymentsNext',
    DECLARATION_BACK: 'declarationBack',
    DECLARATION_CONTINUE: 'declarationContinue',

    CONFIRMATION_SAGA_HOME_PAGE: 'confirmationSagaHomepage',
    CONFIRMATION_NCD_NEXT: 'coverSummaryNoClaimDiscountNext',
    CONFIRMATION_YOUR_COVER_NEXT: 'coverSummaryYourCoverNext',
    CONFIRMATION_YOUR_COVER_AMEND: 'coverSummaryYourCoverAmend',
    CONFIRMATION_MF_ABOUT_INSURANCE_NEXT: 'declarationSectionAboutInsuranceNext',
    CONFIRMATION_MF_YOUR_DECLARATION_NEXT: 'declarationSectionYourDeclarationNext',

    HOME_PREMIUM_PAGE_ACCORDION_CONTINUE: 'homePremiumPageAccordionContinue', // woc-173

    PROPERTY_DETAILS_NEXT: 'nextTabButton_yourPropertyDetails',
    PROPERTY_YOUR_COVER_TEXT: 'nextTabButton_yourCover',
    PROPERTY_CONTINUE: 'nextTabButton_enhanceYourCover',

    POLICYHOLDER_DETAILS_NEXT: 'nextTabButton_yourPersonalDetails',
    POLICYHOLDER_DETAILS_TWO_TEXT: 'nextTabButton_yourPersonalDetailsPart2',
    POLICYHOLDER_CLAIMS_TEXT: 'nextTabButton_yourClaims',
    POLICYHOLDER_MORE_PROPERTY_TEXT: 'nextTabButton_moreAboutYourProperty',
    POLICYHOLDER_CONTINUE: 'nextTabButton_otherInfoAboutYou',

    // WOC-2260 - start
    YOUR_DETAILS_PERSONAL_DETAILS_NEXT: 'nextTabButton_yourPersonalDetails_WOC2260',
    YOUR_DETAILS_PERSONAL_DETAILS_TWO_TEXT: 'nextTabButton_yourPersonalDetailsPart2_WOC2260',
    YOUR_DETAILS_CONTINUE: 'nextTabButton_otherInfoAboutYou_WOC2260',

    YOUR_PROPERTY_DETAILS_NEXT: 'nextTabButton_yourPropertyDetails_WOC2260',
    YOUR_PROPERTY_YOUR_COVER_TEXT: 'nextTabButton_yourCover_WOC2260',
    YOUR_PROPERTY_CLAIMS_TEXT: 'nextTabButton_yourClaims_WOC2260',
    YOUR_PROPERTY_CONTINUE: 'nextTabButton_moreAboutYourProperty_WOC2260',

    YOUR_COVER_CONTINUE: 'nextTabButton_enhanceYourCover_WOC2260',
    // WOC-2260 - end

    SPECITEMS_CONTINUE: 'specifiedItemContinue',
    ENDORSEMENTS_CONTINUE: 'endorsementsContinue',

    ASSUMPTIONS_ABOUT_YOU_NEXT: 'nextTabButton_about-you',
    ASSUMPTIONS_PROPERTY_TEXT: 'nextTabButton_about-your-property',
    ASSUMPTIONS_POLICY_TEXT: 'nextTabButton_about-your-policy',
    ASSUMPTIONS_MONTHLY_TEXT: 'nextTabButton_monthly-payments',

    SPT_DETAILS_SINGLE_TRIP_CONTINUE: 'detailsSingleTripContinue',
    SPT_DETAILS_ANNUAL_TRIP_CONTINUE: 'detailsAnnualTripContinue',
    SPT_DETAILS_TRAVELLERS_CONTINUE: 'detailsTravellersContinue',
    SPT_DETAILS_YOUR_ADDRESS_CONTINUE: 'detailsYourAddressContinue',
    SPT_QUOTE_YOUR_COVER_NEXT: 'premiumYourCoverNext',
    SPT_QUOTE_ENHANCE_YOUR_COVER_NEXT: 'premiumEnhanceYourCoverNext',
    SPT_DETAILS_PAGE_CONTINUE: 'detailsContinue',
    SPT_MEDICAL_PAGE_CONTINUE: 'medicalContinue',
    SPT_MEDICAL_PAGE_BACK: 'medicalBack',
    SPT_AGGS_QUOTE_PAGE_CONTINUE: 'quoteContinue'
};

// Adobe Analytics Product names
const SG_AA_PRODUCT_NAME = {
    TAILORMADE: 'Tailormade',
    LANDLORD: 'Landlord',
    STANDARD: 'standard',
    HOLIDAY: 'Holiday-Others',
    FAMILY: 'Holiday-Family',
    WEEKEND: 'Weekend',
    HOME_UNKNOWN: 'home insurance-unknown',
    HOME: 'home insurance',
    HOME_FIXED: 'home insurance-fixed'
};

// Adobe Analytics Product Categories
const SG_AA_PRODUCT_CATEGORY = {
    HOME: 'home products',
    MOTOR: 'motor products'
};

const SG_AA_TRAFFIC_TYPE = {
    STANDARD: 'nonAgg',
};

// Adobe Analytics Quote type
const SG_AA_QUOTE_TYPE = {
    QUOTE_RETRIEVE: 'retrieve',
    QUOTE_AGGREGATOR: 'aggregator',
    QUOTE_STANDARD: 'standard',
    QUOTE_INDICATIVE: 'indicative',
    QUOTE_FULL: 'full'
};

// Adobe Analytics Quote Journey
const SG_AA_QUOTE_JOURNEY = {
    QUOTE_EDIT: 'edit',
    QUOTE_NON_EDIT: 'non-edit'
};

// MySaga Actions
const SG_MYSAGA_ACTIONS = {
    MOTOR_AMEND: 'MotorInsuranceQuoteAmend',
    MOTOR_BUY: 'MotorInsuranceQuoteBuyNow',
    MOTOR_RENEW: 'MotorInsuranceQuoteRenew',
    MOTORHOME_AMEND: 'MotorHomeInsuranceQuoteAmend',
    MOTORHOME_BUY: 'MotorHomeInsuranceQuoteBuyNow',
    MOTORHOME_RENEW: 'MotorHomeInsuranceQuoteRenew',
    HOME_AMEND: 'HomeInsuranceQuoteAmend',
    HOME_BUY: 'HomeInsuranceQuoteBuyNow',
    HOME_RENEW: 'HomeInsuranceQuoteRenew',
    SMI_AMEND: 'HealthInsuranceQuoteAmend',
    SMI_BUY: 'HealthInsuranceQuoteBuyNow',
    SPT_AMEND: 'TravelInsuranceQuoteAmend',
    SPT_BUY: 'TravelInsuranceQuoteBuyNow'
};

const SG_AA_COVER_LEVELS = {
    ESSENTIAL: 'Saga Essential',
    STANDARD: 'Saga Standard',
    SELECT: 'Saga Select',
    PLUS: 'Saga Plus',
    UNKNOWN: 'UNKNOWN'
};

const SG_AA_CAIS_DIRECTION = {
    CONTINUE: 'continue to card payment',
    BACK: 'back to premium'
};

const SG_AA_RETRIEVAL_FAILURES = {
    FAILURE: 'failedRetrieval',
    LOCKED_OUT: 'lockedOut',
    EXPIRED: 'expiredRetrieval',
    OFFLINE: 'touchedOffline',
    INVALID: 'invalidCover',
    TIA_NUMBER: 'tiaNumber'
};

const SG_AA_PREMIUM_PAGE_ACTION_PAGES = [
    'premium',
    'declarations',
    'quote'
];

const SG_AA_PAGE_TYPE = {
    QUOTE: 'quote',
    IPID: 'ipid',
    RETRIEVAL: 'retrieve'
};

export {
    SG_AA_COVER_TYPE_PRODUCT,
    SG_AA_PREMIUM_PAGE_ACTION,
    SG_AA_COVER_LEVELS,
    SG_AA_CTA_TEXT,
    SG_AA_PROD_ACTION_LOC,
    SG_AA_PROD_ACTION_REASON,
    SG_AA_PRODUCT_CATEGORY,
    SG_AA_FIELDS_ADDONS,
    SG_AA_PRODUCT_NAME,
    SG_AA_QUOTE_JOURNEY,
    SG_MYSAGA_ACTIONS,
    SG_AA_TRAFFIC_TYPE,
    SG_AA_QUOTE_TYPE,
    SG_AA_PAGE_NAME,
    SG_AA_CAIS_DIRECTION,
    SG_CEP_MTA_SUMMARY_PAGES,
    SG_AA_RETRIEVAL_FAILURES,
    SG_AA_PREMIUM_PAGE_ACTION_PAGES,
    SG_AA_PAGE_TYPE
};
